module.exports = __webpack_public_path__ + "static/media/fav.bcc5172b.svg";